// @ts-expect-error jpgs are untyped modules
import HubSpotSolutionsPartner from 'bender-url!../../assets/images/PartnerInfoIllustration.jpg';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { useAppContext } from '../context/AppContext';
import { getSolutionsDirectoryUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PartnerInfoSection({
  flex
} = {}) {
  const {
    isStackedLayout,
    isWrappedLayout
  } = useResponsiveProps({
    isStackedLayout: {
      xs: true,
      xl: false
    },
    isWrappedLayout: {
      xs: false,
      md: true,
      xl: false
    }
  });
  const appContext = useAppContext();
  const lang = getLang();
  return /*#__PURE__*/_jsx(CardWrapper, {
    flex: flex || '1',
    height: "100%",
    children: /*#__PURE__*/_jsxs(Flex, {
      blockSize: "100%",
      flexDirection: isStackedLayout ? 'column' : 'row',
      children: [/*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        backgroundColor: "fill-accent-magenta-subtle",
        flex: "1",
        justifyContent: "center",
        minBlockSize: "376px",
        padding: "600",
        children: /*#__PURE__*/_jsx(Image, {
          alt: "HubSpot solutions partner illustration",
          height: "auto",
          maxInlineSize: isWrappedLayout ? '400px' : '100%',
          inlineSize: isWrappedLayout ? 'auto' : '100%',
          src: HubSpotSolutionsPartner
        })
      }), /*#__PURE__*/_jsxs(CardSection, {
        display: "flex",
        flex: "1",
        flexDirection: "column",
        gap: "400",
        justifyContent: "center",
        padding: "800",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          color: "text-core-subtle",
          textAlign: "start",
          textTransform: "uppercase",
          typography: "heading-25",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.partnerInfoSection.title"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "h3",
          textAlign: "start",
          typography: "heading-300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.partnerInfoSection.subTitle"
          })
        }), /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.partnerInfoSection.description"
          })
        }), /*#__PURE__*/_jsx(View, {
          marginBlockStart: "400",
          children: /*#__PURE__*/_jsx(Button, {
            external: true,
            href: getSolutionsDirectoryUrl(appContext, lang),
            use: "tertiary-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.partnerInfoSection.buttonText"
            })
          })
        })]
      })]
    })
  });
}